import React, { useState } from 'react'
import { PaymentContext } from 'src/components/pages/payment/payment/context/paymentContext'

type PaymentProviderProps = {
  children: React.ReactNode
}

export const PaymentProviderContext: React.FunctionComponent<PaymentProviderProps> = ({ children }) => {
  const [reservationIds, setReservationIds] = useState<number[]>([])
  const [paymentData, setPaymentData] = useState<any>({
    work_unit_token: null,
    work_unit_id: null,
    hash_work_unit: null,
    selectedWorkUnit: null,
    hash_business_unit: null,
    selectedBusinessUnit: null,
  })
  const [paymentCurrecies, setPaymentCurrecies] = useState<any[]>([])
  const [paymentExchanges, setPaymentExchanges] = useState<any[]>([])
  const [itemsSelected, setItemsSelected] = useState<any[]>([])
  const [paymentCredit, setPaymentCredit] = useState<any[]>([])
  const [currency, setCurrency] = useState<any>({})
  const [isReservationOption, setIsReservationOption] = useState<boolean>(false)
  return (
    <PaymentContext.Provider
      value={{
        reservationIds,
        setReservationIds,
        paymentData,
        setPaymentData,
        paymentCurrecies,
        setPaymentCurrecies,
        paymentExchanges,
        setPaymentExchanges,
        itemsSelected,
        setItemsSelected,
        paymentCredit,
        setPaymentCredit,
        currency,
        setCurrency,
        isReservationOption,
        setIsReservationOption,
      }}
    >
      {children}
    </PaymentContext.Provider>
  )
}
